import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
//MUI
import { Box, Button, Container, Divider, Grid, Stack } from "@mui/material";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { theme } from '../../assets/themes';
import UButton from "../../components/mui/UButton";
import UAuthButton from "../../components/mui/UAuthButton";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UConfirmDialog from "../../components/mui/UConfirmDialog";
import UAlertDialog from "../../components/mui/UAlertDialog";
import UPopupForm from "../../components/mui/UPopupForm";
import UTable from "../../components/mui/UTable";

import TillModify from "./TillModify";
import { API, PAGE } from "../../config";
import { fni18n } from "../../services/commonService";
import {
    getAPI
    ,postAPI
    ,putAPI
    ,deleteAPI
    ,fnCallPopUp
} from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";

import USelectBox from "../../components/mui/USelectBox";
import { makeStyles } from "@material-ui/core/styles";

export default function TillPage(){
	const { t } = useTranslation();
    const userLoginId = AuthenticationService.getLoggedInUserID();
    const columns = [
        {
            field: 'storeCd',
            headerName: '지점',
            width: 150,
            editable: true,
            headerAlign: 'center',
            align: 'center',
            hide: true,
        },
        {
            field: 'storeNm',
            headerName: '지점명',
            width: 150,
            editable: true,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'brandCd',
            headerName: '브랜드번호',
            width: 150,
            editable: true,
            headerAlign: 'center',
            align: 'center',
            hide: true,
        },
       {
            field: 'brandNm',
            headerName: '브랜드',
            width: 150,
            editable: true,
            headerAlign: 'center',
            align: 'center',
        },
        {
          field: 'grpNm',
          headerName: '그룹명',
          width: 150,
          editable: true,
          headerAlign: 'center',
          align: 'center',
        },
        {
          field: 'cnt100D',
          headerName: '$100',
          width: 60,
          editable: true,
          headerAlign: 'center',
            align: 'right',
        },
        {
          field: 'cnt50D',
          headerName: '$50',
          width: 60,
          editable: true,
          headerAlign: 'center',
            align: 'right',
        },
        {
            field: 'cnt20D',
            headerName: '$20',
            width: 60,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },
        {
            field: 'cnt10D',
            headerName: '$10',
            width: 60,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },
        {
            field: 'cnt5D',
            headerName: '$5',
            width: 60,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },
        /*{
            field: 'cnt2D',
            headerName: '2$',
            width: 60,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },*/
        {
            field: 'cnt1D',
            headerName: '$1',
            width: 60,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },
        /*{
            field: 'cnt100C',
            headerName: '100¢',
            width: 60,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },
        {
            field: 'cnt50C',
            headerName: '50¢',
            width: 60,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },*/
        {
            field: 'cnt25C',
            headerName: '25¢',
            width: 60,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },
        {
            field: 'cnt10C',
            headerName: '10¢',
            width: 60,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },
        {
            field: 'cnt5C',
            headerName: '5¢',
            width: 60,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },
        {
            field: 'cnt1C',
            headerName: '1¢',
            width: 60,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },
        {
            field: 'dayLimtCnt',
            headerName: '1일출금횟수',
            width: 100,
            editable: true,
            headerAlign: 'center',
            align: 'right',
            hide: true,
        },
        {
            field: 'dayLimtAmt',
            headerName: '1일출금한도',
            width: 100,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },
        {
            field: 'tranctAmt',
            headerName: '1회출금한도',
            width: 100,
            editable: true,
            headerAlign: 'center',
            align: 'right',
        },
        {
            field: 'button',
            headerName: '설정',
            sortable: false,
            width: 100,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) =>
            (
                <UButton
                variant="outlined"
                onButtonClick={()=>handleRowSelect(params.rows)}
                menuFrom={location.pathname}
                >
                    보기
                </UButton>
            ),
        },
    ];
    
    const location = useLocation();
    const [branchs, setBranch] = useState([]);
    const [brands, setBrands] = useState([]);
    const [groups, setGroups] = useState([]);
    const [retailers, setRetailers] = useState([]);
    const [search, setSearch] = useState({
        // branch : "N/A",
        // brandCd : "N/A",
    });

    const [confirmPopupOpen, setConfirmPopupOpen] = useState(false); // confirm dialog
    const [errorPopupOpen, setErrorPopupOpen] = useState(false); // error dialog
    const [errorMsg, setErrorMsg] = useState(""); // api error message
    const [confirmMsg, setConfirmMsg] = useState(""); // api error message
    const [confirmEvent, setConfirmEvent] = useState(""); 
    const [ formOpen, setFormOpen ] = useState(false);
    const [modify, setModify] = useState({});
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [list, setList] = useState([]);
    const [total, setTotal] = useState();
    //화면 로드 시
    useEffect(() => {
        window.scrollTo(0, 0);
        const getLoadData = async () => {
            try {
                await Promise.all([
                    loadComboBoxBranchGroup(),
                    loadComboBoxBranch(),
                    loadComboBoxGroup()
                ]);
            } catch (e) {
                console.log(e)
            }
        };
        getLoadData();
    }, []);

    useEffect(() => {
        setTotal(0)
        if (!isFirstLoad) return;
        if (search.branch) {
            onButtonClick("조회");
            setIsFirstLoad(false);
        }
    }, [search]);

    useEffect(()=>{
        let total = 0;
        total = modify.cnt100D*100+modify.cnt50D*50+modify.cnt20D*20+modify.cnt10D*10+modify.cnt5D*5+modify.cnt1D*1+modify.cnt25C*0.25+modify.cnt10C*0.1+modify.cnt5C*0.05+modify.cnt1C*0.01;
        if(total==NaN || total=='NaN' || Number.isNaN(total)){
            total=0;
        }
        setTotal({
            dayLimtAmt : modify.dayLimtCnt*total,
            tranctAmt : total,
        })
    }, [modify])

    const clearSearchVal = ()=>{
        setSearch({
            ...search,
            ['branch']: 'N/A',
        });
        setBrands([]);
    }

    // 콤보박스 데이터
    const loadComboBoxBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRetailers(_inputData);
            // await loadComboBoxBranch(_inputData[0].cd);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxGroup = async () => {
        try{
            const res = await getAPI(API.COMMON.USER_GROUP);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.grpCd,
                    name: m.grpNm,
                })
            );
            setGroups(_inputData );
        }catch(e){
            console.error(e.message);
        }
    }; 
    // 콤보박스 데이터
    const loadComboBoxBranch = async(param) => {
        try{
            const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param, });
            const _inputData = res.data.result.map((m) => ({
                     cd: m.storeCd,
                     name: m.storeNm,
                 })
            );
            // setSearch({
            //     ...search,
            //     ['branch'] : _inputData[0].cd,
            // })
            setBranch(_inputData );
            if (_inputData.length > 0){
                await loadComboBoxBrand(_inputData[0].cd);
            } else {
                clearSearchVal()
            }
        }catch(e){
            console.error(e.message);
        }
    };
    const loadComboBoxBrand = async (branch) => {
        try{
            const res = await getAPI(API.COMMON.BRAND, { userId: userLoginId, branch: branch});
            const _inputData = res.data.result.map((m) => ({
                    cd: m.brandCd,
                    name: m.brandNm,
                })
            );
            if (_inputData.length > 0) {
                setSearch({
                    ...search,
                    ['brandCd'] : _inputData[0].cd,
                    ['branch'] : branch,
                })
            } else {
                setSearch({
                    ...search,
                    ['brandCd'] : "N/A",
                    ['branch'] : branch,
                })
            }
            setBrands(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    const handleConfirmOpen = (e) => {
        setConfirmPopupOpen(true);
        setConfirmEvent(e)
    };
    const handleConfirmClose = () => {
        setConfirmPopupOpen(false);
    };
    /**처리성공 시 팝업 띄우지 않는다. 실패 시에만 팝업 띄운다 */
    /**처리실패 시에는 창 닫지 않는다. 성공 시에만 자동 closed.*/
    const handelConfirmEvent = async () => {
        let data = {
            storeCd : modify.storeCd,
            storeNm : modify.storeNm,
            brandCd : modify.brandCd,
            brandNm : modify.brandNm,
            grpNm : modify.grpNm,
            cnt100D : modify.cnt100D,
            cnt50D : modify.cnt50D,
            cnt20D : modify.cnt20D,
            cnt10D : modify.cnt10D,
            cnt5D : modify.cnt5D,
            cnt1D : modify.cnt1D,
            cnt25C : modify.cnt25C,
            cnt10C : modify.cnt10C,
            cnt5C : modify.cnt5C,
            cnt1C : modify.cnt1C,
            cntLimt : modify.dayLimtCnt,
            total : total.tranctAmt,
        };
        try{
            if(confirmEvent==="put"){
                await putAPI(API.OPER.TILL, data).then((res) =>{
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(res.data.message || "Processing failed.");
                        handleErrorOpen();
                    }
                })
            }else if(confirmEvent==="post"){
                await postAPI(API.OPER.TILL, data).then((res) =>{
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"))
                        handleErrorOpen();
                    }
                })
            }else if(confirmEvent==="delete"){
                await deleteAPI(API.OPER.TILL, data).then((res) =>{
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"))
                        handleErrorOpen();
                    }
                })
            }
        }catch (error) {
            console.log(error)
        } finally {
            handleConfirmClose();
            await onButtonClick("조회");
        }
    };

    const handleErrorOpen = () => {
        setErrorPopupOpen(true);
    };
    const handleErrorClose = () => {
        setErrorPopupOpen(false);
    };

    const handleRowSelect = (row) => {
        setModify({ 
            storeCd : row.storeCd,
            storeNm : row.storeNm,
            brandCd : row.brandCd,
            brandNm : row.brandNm,
            grpNm : row.grpNm,
            cnt100D : row.cnt100D||0,
            cnt50D : row.cnt50D||0,
            cnt20D : row.cnt20D||0,
            cnt10D : row.cnt10D||0,
            cnt5D : row.cnt5D||0,
            cnt1D : row.cnt1D||0,
            cnt25C : row.cnt25C||0,
            cnt10C : row.cnt10C||0,
            cnt5C : row.cnt5C||0,
            cnt1C : row.cnt1C||0,
            dayLimtCnt : row.dayLimtCnt||0,
            chkCreate : row.grpNm||"",
        })
        handleFormOpen();   //상세팝업
    }

    const handleFormOpen = () => {
        setFormOpen(true);
    };
    const handleFormClose = () => {
        setFormOpen(false);
    };

    //DataGrid에서 row 선택 시 
    function onSelectedRow(row){
    };
    const onSelectedRows = (e, row) => {
    };
    const onModifyChange = (e) => {
        const { name, value } = e.target;
        setModify({
            ...modify,
            [name]: value,
        });
    };
    const onModifyStoreChage = (e) =>{
        setModify({
            ...modify,
            "brandCd":e.brandCd.value,
            "storeCd":e.storeCd.value,
        })
    };

    //검색조건 값 변경되었을 때
    const onSearchChange = async (e) => {
        const {name, value} = e.target;
        setSearch({
            ...search,
            [name] :value,
        })
        if (name === "bizTy") {
            loadComboBoxBranch(value);
        }
        if(name=='branch'){
            await loadComboBoxBrand(value);
        }
    }

    async function onButtonClick(dvsn){
        if(dvsn==="삭제"){
            let flag;
            let data = {
                storeCd : modify.storeCd,
                storeNm : modify.storeNm,
                brandCd : modify.brandCd,
                brandNm : modify.brandNm,
                grpNm : modify.grpNm,
                cnt100D : modify.cnt100D,
                cnt50D : modify.cnt50D,
                cnt20D : modify.cnt20D,
                cnt10D : modify.cnt10D,
                cnt5D : modify.cnt5D,
                cnt1D : modify.cnt1D,
                cnt25C : modify.cnt25C,
                cnt10C : modify.cnt10C,
                cnt5C : modify.cnt5C,
                cnt1C : modify.cnt1C,
                cntLimt : modify.dayLimtCnt,
                total : total.tranctAmt,
            }
            await getAPI(API.OPER.TILL+'/duplicateCheck', data).then((res) =>{
                flag=res.data;
            })
            if(flag==-1){
                setErrorMsg(t("지점")+t("은(는) 필수 입력 항목입니다"));
                handleErrorOpen();
            }else if(flag==-2){
                setErrorMsg(t("브랜드")+t("은(는) 필수 입력 항목입니다"));
                handleErrorOpen();
            }else if(flag==-3){
                setErrorMsg(t("사용자그룹")+t("은(는) 필수 입력 항목입니다"));
                handleErrorOpen();
            }else if(flag==1){
                setConfirmMsg(t("삭제하시겠습니까?")+data.grpNm);
                handleConfirmOpen("delete");
            }else {
                setErrorMsg(t("해당 설정이 존재하지 않습니다."));
                handleErrorOpen();
            }
        }else if(dvsn==="추가"){
            const row = ({
                storeCd : "",
                storeNm : "",
                brandCd : "",
                brandNm : "",
                grpNm : "",
                cnt100D : 0,
                cnt50D : 0,
                cnt20D : 0,
                cnt10D : 0,
                cnt5D : 0,
                cnt1D : 0,
                cnt25C : 0,
                cnt10C : 0,
                cnt5C : 0,
                cnt1C : 0,
                dayLimtCnt : 0,
                chkCreate : "",
            });
            handleRowSelect(row);
        }else if(dvsn==="조회"){
            await getAPI(API.OPER.TILL, search).then((res) =>{
                if (res.data.code === 200) {
                    const _inputData = res.data.result.map((rowData) => ({
                        id: rowData.id,
                        storeCd : rowData.storeCd,
                        storeNm : rowData.storeNm,
                        brandCd : rowData.brandCd,
                        brandNm : rowData.brandNm,
                        grpNm : rowData.grpNm,
                        cnt100D : rowData.cnt100D,
                        cnt50D : rowData.cnt50D,
                        cnt20D : rowData.cnt20D,
                        cnt10D : rowData.cnt10D,
                        cnt5D : rowData.cnt5D,
                        cnt2D : rowData.cnt2D,
                        cnt1D : rowData.cnt1D,
                        cnt100C : rowData.cnt100C,
                        cnt50C : rowData.cnt50C,
                        cnt25C : rowData.cnt25C,
                        cnt10C : rowData.cnt10C,
                        cnt5C : rowData.cnt5C,
                        cnt1C : rowData.cnt1C,
                        dayLimtCnt : rowData.dayLimtCnt,
                        dayLimtAmt : "$"+Number(rowData.dayLimtAmt).toLocaleString("en-US"),
                        tranctAmt : "$"+Number(rowData.tranctAmt).toLocaleString("en-US"),
                        useYn : rowData.useYn,
                    }));
                    setList(_inputData);
                } else {
                    setErrorMsg(t("처리가 실패하였습니다"))
                    handleErrorOpen();
                }
            })
        }else {
            setErrorMsg(t("알 수 없는 오류가 발생하였습니다"))
            handleErrorOpen();
        }
    };
    const onSave =async(e) =>{
        let flag;
        let data = {
            storeCd : modify.storeCd,
            storeNm : modify.storeNm,
            brandCd : modify.brandCd,
            brandNm: modify.brandNm,
            grpNm : modify.grpNm,
            cnt100D : modify.cnt100D,
            cnt50D : modify.cnt50D,
            cnt20D : modify.cnt20D,
            cnt10D : modify.cnt10D,
            cnt5D : modify.cnt5D,
            cnt1D : modify.cnt1D,
            cnt25C : modify.cnt25C,
            cnt10C : modify.cnt10C,
            cnt5C : modify.cnt5C,
            cnt1C : modify.cnt1C,
            cntLimt : modify.dayLimtCnt,
            total : total.tranctAmt,
        }
        await getAPI(API.OPER.TILL+'/duplicateCheck', data).then((res) =>{
            flag=res.data;
        })
        if(flag==-1){
            setErrorMsg(t("지점")+t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        }else if(flag==-2){
            setErrorMsg(t("브랜드")+t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        }else if(flag==-3){
            setErrorMsg(t("사용자그룹")+t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        }else if(flag==0){
            setConfirmMsg(t("등록하시겠습니까?"));
            handleConfirmOpen("post");
        }else if(flag==1){
            setConfirmMsg(t("정보를 수정하시겠습니까?"));
            handleConfirmOpen("put");
        }else {
            setErrorMsg(t("알 수 없는 오류가 발생하였습니다"));
        }
    }

    return(
        <div className="main-container">
            <div className="header">
                <Grid container>
                    <Grid item xs={10}>
                        {/* 상단메뉴명 */}
                        <UBreadCrumbs
                            title={"운영관리"}
                            subtitle={"준비금관리"}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        {/* 툴바 버튼 */}
                        <Stack 
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="flex-start"
                            spacing={0.5}
                        >
                        </Stack>
                    </Grid>
                </Grid>
            </div>
        
        <div className="contents">
            <Box>
            {/* 조회조건 */}        
                <TableContainer className="table-container">
                <Table className="table" size="small">
                    <TableBody>
                        <TableRow className="table-row-header">
                            <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                            <TableCell className="table-cell">
                                <USelectBox
                                    name="bizTy"
                                    items={retailers}
                                    onItemChange={onSearchChange}
                                />
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                            <TableCell className="table-cell">
                                {/* 점번선택 */}
                                <USelectBox id="branch" name="branch" items={branchs} onItemChange={onSearchChange} defaultValue={search.branch}/>
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('브랜드')}</TableCell>
                            <TableCell className="table-cell">
                                <USelectBox
                                    id="brandCd"
                                    name="brandCd"
                                    items={brands}
                                    onItemChange={onSearchChange}
                                    defaultValue={search.brandCd}
                                />
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('사용자그룹')}</TableCell>
                            <TableCell className="table-cell">
                                {/* 그룹선택 */}
                                <USelectBox
                                    id="grpCd"
                                    name="grpCd"
                                    items={groups}
                                    onItemChange={onSearchChange} />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                </TableContainer>
                <div className="search">
                    <UButton icon="Search" onButtonClick={onButtonClick}>조회</UButton>
                </div>
            </Box>
            {/* 조회 리스트 */}
            <UTable columns={columns} rows={list}
                onSelectedRowChange={onSelectedRows}
                rowPerPage={11}
                toolbarAdd={
                    <UAuthButton icon="Add" menuFrom={location.pathname} onButtonClick={onButtonClick}>추가</UAuthButton>
                }
            />
        </div>

        <UConfirmDialog
            message={confirmMsg}
            open={confirmPopupOpen}
            onClose={handleConfirmClose}
            onClickOk={handelConfirmEvent}
        />
        <UAlertDialog
            message={errorMsg}
            open={errorPopupOpen}
            onClose={handleErrorClose}
        />
        {/* 팝업 */}
        <UPopupForm
            open={formOpen}
            onClose={handleFormClose}
            onSave={onSave}
            title='준비금 설정'//'준비금 설정'
            type={"2"}
            content={<TillModify data={modify} total={total} onParamsChange={onModifyChange} onStoreChage={onModifyStoreChage}/>}
        />
    </div>
    );
}
